module.exports = __webpack_public_path__ + "static/icon11-e458dc5dd105c7c9571e5f2500616535.svg";